import { default as _91_46_46_46slug_93S3mdMMh7a1Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/[...slug].vue?macro=true";
import { default as indexezV210PxtnMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/auth/index.vue?macro=true";
import { default as indexXWKNYiqTFWMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93iZddKLoeVDMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93ru9YRtTaJBMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93LqR9dmI8FvMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93xR3AniESVRMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/news/[slug].vue?macro=true";
import { default as organisationsd3ejMennMhMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45events2hrlAxmIqjMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programscturMs64vuMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexTbBOSklb0nMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/processes/index.vue?macro=true";
import { default as dungeondo60Hrm3mqMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsDlXZJJsPJoMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexqS2c0xMJDhMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/secret/index.vue?macro=true";
import { default as indexm5p19xuIZQMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataiYGsHTKVigMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassKTecCib5PIMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93DD7dbylCX6Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexXdF4LAUZtBMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataIR7SQZabmOMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsCETWMpXydHMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsSvGIOrWWoYMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsPrlsd1jVUYMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93mCQIdS2BWAMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as indexIdstiHCzndMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesdUJmxzcxhlMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataXsTRN3MvuNMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_936hdzyok0d0Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexYsEsHFAKLEMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivities3Ugtv14cdKMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseData93UPqvQGxlMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93PLAvs6GFR4Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indextjlY14dSPYMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataigzgcjEv6AMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93qUNDgJ8wQCMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexwJ9C5wYpfFMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataBVNkbMTFVJMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassVLKxxEYHxOMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedForms9SXACQETwgMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_939tSdtpgQV5Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexlKiiCSmbRrMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesAvfzB42DJcMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDatab81aTAN6MYMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsSVLmgcfAfsMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93X9rGkOIruCMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexQGwkKBlEBSMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesDqFjwbQEXaMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDatalEnfRPq33bMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsZd5kHfdG2rMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93c8GlTiSGKKMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexpUXgT69wjaMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataEKZsf90fuqMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataRlXiPZBWFIMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93YKdH0TAffXMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexsUxfRwXudDMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatazP0wkr3RKjMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93LZKqXP3stDMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexDd0jgyyVZRMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsZ5ACh95Q9XMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataTHczLPEb0PMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93uP3y4MP2n3Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as index1UsBheUyIcMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishes9WvtFPPJC2Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesBIP93wsgzvMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsWPpDUKSXH9Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseData621mwPxjAkMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasvjJv3aRlhzMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesWTr6YooZM8Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93TatEkWE4hOMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexpPxmhGTihpMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regions2V2TyoqrUMMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltuabxx9eGMrMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataVuIhRhAc68Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsMW7xI1aZiDMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93h4V2K482Y8Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index5HoKx6RNIZMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsmZJalMTCg8Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesj1VcpSJfY9Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataKUWPJr5F8DMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93YSdsROoLCiMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/[id].vue?macro=true";
import { default as indexpPJUGCXXHOMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/index.vue?macro=true";
import { default as massApproval8RVrVZbnYaMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93M3rVYUwwsHMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexcLSIPNUppaMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersiVqyf9viL4Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesdM2wU95uHJMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingstuKKFg29fFMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatac1lTwb0EWqMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesQS1QC0SWaoMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptHq2AvjhOX6Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementm4oTNqykD7Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers4kcWXwByW9Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93LYPWYh1avSMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexsHDKI2koqaMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsFoSntKlIYsMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitieshGMyM4jtMoMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDatagT0qeEpuLVMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersGj1ieyo8boMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatures91M2kIdCQMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93vY94B3VEeeMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexLCybgUoaqQMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/index.vue?macro=true";
import { default as userszrtfs0iMiGMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users.vue?macro=true";
import { default as settings8h3NTiL8myMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesuDfY0vSPdHMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatanEr3hzHvWtMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93OUbQUheDm7Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as index80kGah9yYWMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceZSwaEXcJrEMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service.vue?macro=true";
import { default as languagej9xI4gBY6SMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseData7mWIZBGa2OMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesqfM5yCPBegMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementFEpGqcx8ujMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUserszdJ0yuZ9HMMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93kYFz9osJcBMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatan3WYusupvJMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignature5PNyHtQ1cAMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93SjvigSM8AzMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/[id].vue?macro=true";
import { default as index236tBJD99MMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/index.vue?macro=true";
import { default as settings2vfhKHi6zLMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings.vue?macro=true";
import { default as signature94vb8oSv6pMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/signature.vue?macro=true";
import { default as sportbizz4BuzpTlDuMMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93GR88P0KNuYMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93DKx4Ehg2LdMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexX0G2uITGLtMeta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93ekjrpPoc69Meta } from "/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93S3mdMMh7a1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexezV210PxtnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexXWKNYiqTFWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93iZddKLoeVDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93ru9YRtTaJBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93LqR9dmI8FvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsd3ejMennMhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexTbBOSklb0nMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceZSwaEXcJrEMeta?.name,
    path: "/service",
    meta: serviceZSwaEXcJrEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatazP0wkr3RKjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexm5p19xuIZQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93DD7dbylCX6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexXdF4LAUZtBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93mCQIdS2BWAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: indexIdstiHCzndMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_936hdzyok0d0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexYsEsHFAKLEMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93PLAvs6GFR4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indextjlY14dSPYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93qUNDgJ8wQCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexwJ9C5wYpfFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_939tSdtpgQV5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexlKiiCSmbRrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93X9rGkOIruCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexQGwkKBlEBSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93c8GlTiSGKKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsZd5kHfdG2rMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexpUXgT69wjaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93YKdH0TAffXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexsUxfRwXudDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93LZKqXP3stDMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishes9WvtFPPJC2Meta?.name,
    path: "parishes",
    meta: parishes9WvtFPPJC2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93uP3y4MP2n3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regions2V2TyoqrUMMeta?.name,
    path: "regions",
    meta: regions2V2TyoqrUMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93TatEkWE4hOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsmZJalMTCg8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93h4V2K482Y8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index5HoKx6RNIZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93YSdsROoLCiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexpPJUGCXXHOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApproval8RVrVZbnYaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settings8h3NTiL8myMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersiVqyf9viL4Meta?.name,
    path: "loginProviders",
    meta: loginProvidersiVqyf9viL4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93M3rVYUwwsHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexcLSIPNUppaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsFoSntKlIYsMeta?.name,
    path: "organisations",
    meta: organisationsFoSntKlIYsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93LYPWYh1avSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexsHDKI2koqaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: userszrtfs0iMiGMeta?.name,
    path: "users",
    meta: userszrtfs0iMiGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93vY94B3VEeeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexLCybgUoaqQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93OUbQUheDm7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: index80kGah9yYWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settings2vfhKHi6zLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93kYFz9osJcBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93SjvigSM8AzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: index236tBJD99MMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signature94vb8oSv6pMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizz4BuzpTlDuMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93GR88P0KNuYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93DKx4Ehg2LdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexX0G2uITGLtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93ekjrpPoc69Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250624140436/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]